import React, { useState, useEffect, forwardRef } from 'react';

//komponen
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import LoadingButton from '@mui/lab/LoadingButton';

import SaveOutlined from '@mui/icons-material/SaveOutlined';

function Open_Close(props, ref) {
    //state
    const [proses, setProses] = useState(false);
    const [tampil_notif, setTampilNotif] = useState(false);
    const [jenis_notif, setJenisNotif] = useState("success");
    const [isi_notif, setIsiNotif] = useState("");
    const [status, setStatus] = useState(false);
    const [label_status, setLabelStatus] = useState("Closing");
    const [ppn, setPpn] = useState(0);
    const [ppn_dine_in, setPpnDineIn] = useState(false);
    const [label_dine_in, setLabelDineIn] = useState("Tidak");
    const [ppn_take_away, setPpnTakeAway] = useState(false);
    const [label_take_away, setLabelTakeAway] = useState("Tidak");
    const [biaya_lainnya, setBiayaLainnya] = useState(0);

    //fungsi
    useEffect(() => {
        fetch(props.aplikasi + '/pengaturan/tampil_pengaturan.php',
            {
                method: 'GET',
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    if (data.data[0].status_opening === "1") {
                        setStatus(true);
                        setLabelStatus("Opening");
                    }
                    else {
                        setStatus(false);
                        setLabelStatus("Closing");
                    }

                    setPpn(data.data[0].ppn);

                    if (data.data[0].ppn_dine_in === "1") {
                        setPpnDineIn(true);
                        setLabelDineIn("Ya");
                    }
                    else {
                        setPpnDineIn(false);
                        setLabelDineIn("Tidak");
                    }

                    if (data.data[0].ppn_take_away === "1") {
                        setPpnTakeAway(true);
                        setLabelTakeAway("Ya");
                    }
                    else {
                        setPpnTakeAway(false);
                        setLabelTakeAway("Tidak");
                    }

                    setBiayaLainnya(data.data[0].biaya_lainnya);
                }
                else {
                    setStatus(false);
                    setLabelStatus("Closing");
                    setPpn(0);
                    setPpnDineIn(false);
                    setLabelDineIn("Tidak");
                    setPpnTakeAway(false);
                    setLabelTakeAway("Tidak");
                    setBiayaLainnya(0);
                }
            })
            .catch(error => {
                setStatus(false);
                setLabelStatus("Closing");
                setPpn(0);
                setPpnDineIn(false);
                setLabelDineIn("Tidak");
                setPpnTakeAway(false);
                setLabelTakeAway("Tidak");
                setBiayaLainnya(0);
            }
            );
    }, [props.aplikasi]);

    const tutup_notif = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setTampilNotif(false);
    };

    const ubah_ppn = (event) => {
        const re = /^[+-]?\d*(?:[.]\d*)?$/;
        if (re.test(event.target.value) === false && event.target.value !== "") {
            return;
        }

        setPpn(event.target.value);
    }

    const perbaiki_ppn = (event) => {
        if (event.target.value.trim() === "") {
            setPpn(0);
        }
    }

    const ubah_biaya_lainnya = (event) => {
        const re = /^[+-]?\d*(?:[.]\d*)?$/;
        if (re.test(event.target.value) === false && event.target.value !== "") {
            return;
        }
        setBiayaLainnya(event.target.value);
    }

    const perbaiki_biaya_lainnya = (event) => {
        if (event.target.value.trim() === "") {
            setBiayaLainnya(0);
        }
    }

    const simpan = () => {
        setProses(true);
        fetch(props.aplikasi + '/pengaturan/simpan_open_close.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        status: status,
                        ppn: ppn,
                        ppn_dine_in: ppn_dine_in,
                        ppn_take_away: ppn_take_away,
                        biaya_lainnya: biaya_lainnya
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setJenisNotif("success");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                    setProses(false);
                }
                else {
                    setJenisNotif("warning");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                    setProses(false);
                }
            })
            .catch(error => {
                setJenisNotif("error");
                setIsiNotif("Terjadi kesalahan");
                setTampilNotif(true);
                setProses(false);
            }
            );
    }

    return (
        <div>
            <Snackbar
                open={tampil_notif}
                autoHideDuration={3000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={tutup_notif}
            >
                <Alert
                    severity={jenis_notif}
                    variant="filled"
                    onClose={tutup_notif}
                    sx={{ width: '100%' }}
                >
                    {isi_notif}
                </Alert>
            </Snackbar>

            <Box
                sx={{
                    backgroundColor: "#eff0f0",
                    width: "100%",
                    height: "100%"
                }}
            >
                {/* <Card
                    sx={{ margin: "10px", padding: "10px" }}
                >
                    <Grid container spacing={1}>
                        <Grid container item>
                            <Grid item xs={4} sm={4} md={3} >
                                <Typography variant="body2">
                                    Buka / Tutup Transaksi
                                </Typography    >
                            </Grid>

                            <Grid item xs={8} sm={8} md={9}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={status}
                                            onChange={(event) => {
                                                if (status === false) {
                                                    setStatus(true);
                                                    setLabelStatus("Opening");
                                                }
                                                else {
                                                    setStatus(false);
                                                    setLabelStatus("Closing");
                                                }

                                                fetch(props.aplikasi + '/pengaturan/simpan_open_close.php',
                                                    {
                                                        method: 'POST',
                                                        body: JSON.stringify
                                                            ({
                                                                status: event.target.checked
                                                            }),
                                                        headers:
                                                        {
                                                            "Content-type": "application/json; charset=UTF-8"
                                                        }
                                                    })
                                                    .then(response => response.json())
                                                    .then(data => {
                                                        if (data.kode === 1) {

                                                        }
                                                        else {

                                                        }
                                                    })
                                                    .catch(error => {

                                                    }
                                                    );
                                            }}
                                        />
                                    }

                                    label={label_status}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Card> */}

                <Card
                    sx={{ margin: "10px", padding: "10px" }}
                >
                    <Grid container spacing={1}>
                        <Grid container spacing={1} item>
                            <Grid item xs={6} sm={4} md={2} >
                                <Typography variant="body2">
                                    Buka / Tutup Transaksi
                                </Typography>
                            </Grid>

                            <Grid item xs={6} sm={8} md={10}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={status}
                                            onChange={(event) => {
                                                if (status === false) {
                                                    setStatus(true);
                                                    setLabelStatus("Opening");
                                                }
                                                else {
                                                    setStatus(false);
                                                    setLabelStatus("Closing");
                                                }
                                            }}
                                        />
                                    }

                                    label={label_status}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={1} item>
                            <Grid item xs={6} sm={4} md={2} >
                                <Typography variant="body2">
                                    PPN
                                </Typography>
                            </Grid>

                            <Grid item xs={6} sm={8} md={10}>
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment>
                                                %
                                            </InputAdornment>
                                        ),
                                    }}
                                    value={ppn}
                                    onChange={(e) => ubah_ppn(e)}
                                    onBlur={(e) => perbaiki_ppn(e)}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={1} item>
                            <Grid item xs={6} sm={4} md={2} >
                                <Typography variant="body2">
                                    PPN Dine-in
                                </Typography>
                            </Grid>

                            <Grid item xs={6} sm={8} md={10}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={ppn_dine_in}
                                            onChange={(event) => {
                                                if (ppn_dine_in === false) {
                                                    setPpnDineIn(true);
                                                    setLabelDineIn("Ya");
                                                }
                                                else {
                                                    setPpnDineIn(false);
                                                    setLabelDineIn("Closing");
                                                }
                                            }}
                                        />
                                    }

                                    label={label_dine_in}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={1} item>
                            <Grid item xs={6} sm={4} md={2} >
                                <Typography variant="body2">
                                    PPN Take-away
                                </Typography>
                            </Grid>

                            <Grid item xs={6} sm={8} md={10}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={ppn_take_away}
                                            onChange={(event) => {
                                                if (ppn_take_away === false) {
                                                    setPpnTakeAway(true);
                                                    setLabelTakeAway("Ya");
                                                }
                                                else {
                                                    setPpnTakeAway(false);
                                                    setLabelTakeAway("Closing");
                                                }
                                            }}
                                        />
                                    }

                                    label={label_take_away}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={1} item>
                            <Grid item xs={6} sm={4} md={2} >
                                <Typography variant="body2">
                                    Biaya Layanan
                                </Typography>
                            </Grid>

                            <Grid item xs={6} sm={8} md={10}>
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment>
                                                %
                                            </InputAdornment>
                                        ),
                                    }}
                                    value={biaya_lainnya}
                                    onChange={(e) => ubah_biaya_lainnya(e)}
                                    onBlur={(e) => perbaiki_biaya_lainnya(e)}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={1} item>
                            <Grid item xs={6} sm={4} md={2} />

                            <Grid item xs={6} sm={8} md={10}>
                                <LoadingButton
                                    loadingPosition="start"
                                    variant="contained"
                                    color="primary"
                                    startIcon={<SaveOutlined />}
                                    sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em" }}
                                    loading={proses}
                                    onClick={() => simpan()}
                                >
                                    <Typography variant="body2" noWrap={true}>Simpan</Typography>
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </Grid>
                </Card>
            </Box>
        </div>
    );
}

export default forwardRef(Open_Close);